import { render, staticRenderFns } from "./WorkshopEdit.vue?vue&type=template&id=7a3399cb"
import script from "./WorkshopEdit.vue?vue&type=script&lang=ts"
export * from "./WorkshopEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports